<!-- eslint-disable prettier/prettier -->

<template>
  <div class="page">
    <div class="home_top_div">
      <div id="mainslider">
        <splide :options="options">
          <splide-slide v-for="(banner,idx) in bannerList" :key="idx">
            <img class="main_img" :src="`https://ptbidplus.net/member-api/api/banner/${banner.배너순번}`" :alt="`main${idx + 1}`" @click="goLink(banner)" />
          </splide-slide>
        </splide>
      </div>
      <div v-if="!store.isLogin" class="user_info_div">
        <img class="user_info_img" src="@/assets/images/certificate_icon.png" />
        <div class="user_info_desc">공동인증서로<br />로그인 하세요</div>
        <div class="user_info_btn_group">
          <div class="main_btn" @click="goPage('login')">로그인</div>
          <div class="main_sub_btn" @click="goPage('signup')">회원가입</div>
        </div>
      </div>
      <div v-else class="mypage_info_div">
        <img class="mypage_info_img" v-if="store.isLogin" src="@/assets/images/total_mypage.png" />
        <img class="mypage_info_img" v-if="store.isLogin && store.userInfo?.수주수행구분 == '수행'" src="@/assets/images/normal_mypage.png" />
        <div class="user_info_desc">{{ store.userInfo.사업자명 }}</div>
        <div class="profile-div">
          <div class="profile-type">통합회원</div>
        </div>
        <div class="main_btn" @click="goPage('mypage')">마이페이지</div>
        <div>
          <li class="title_menu_li" @click="logout()">로그아웃</li>
        </div>
      </div>
    </div>
    <div class="home_main_div">
      <div class="home_menu_div">
        <div class="home_menu" @click="goPage('notice')">
          <img class="home_menu_img" src="@/assets/images/notice_menu_icon.png" />
          <div class="home_menu_label">공지사항</div>
        </div>
        <div class="home_menu" @click="goPage('announce')">
          <img class="home_menu_img" src="@/assets/images/announce_menu_icon.png" />
          <div class="home_menu_label">공고관리</div>
        </div>
        <div class="home_menu" @click="goPage('mypage')">
          <img class="home_menu_img" src="@/assets/images/mypage_menu_icon.png" />
          <div class="home_menu_label">마이페이지</div>
        </div>
        <div class="home_menu" @click="goPage('resourceBoard')">
          <img class="home_menu_img" src="@/assets/images/data_menu_icon.png" />
          <div class="home_menu_label">자료실</div>
        </div>
      </div>
      <div class="home_announce_div">
        <div class="home_announce_header">
          <div class="announce_category_tab">공지사항</div>
          <div
            style="font-size: 32px; height: 32px;line-height: 20px;margin-left:auto;cursor: pointer;" 
            @click="goPage('notice')">+
          </div>
        </div>
        <div class="main_table_div">
          <ul class="main_notice_ul">
            <li class="main_notice_li" v-for="(notice, index) in noticeList" :key="index" @click="goNoticeDetail(notice)">
              <div class="main_notice_title">{{ notice.제목 }}</div>
              <div class="main_notice_date">{{ convertDate(notice.게시시작일) }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="home_announce_div">
        <div class="home_announce_header">
          <div class="announce_category_tab">공고관리</div>
          <div v-if="store.isLogin" 
            style="font-size: 32px; height: 32px;line-height: 20px;margin-left:auto;cursor: pointer;" 
            @click="goPage('announce')">+
          </div>
        </div>
        <div class="main_table_div">
          <div class="no_login_div" v-if="!store.isLogin">로그인을 하셔야 조회가 가능합니다.</div>
          <div class="no_login_div" v-else-if="store.userInfo.가입상태 === '신청'">가입승인 후 이용하실 수 있습니다.</div>
          <ul class="main_notice_ul" v-if="store.isLogin && store.userInfo.가입상태 !== '신청'">
            <li class="main_notice_li" v-for="(announce, index) in announceList" :key="index" @click="goAnnounceDetail(announce)">
              <div class="main_notice_title">{{ announce.공고명 }}</div>
              <div class="main_notice_date">{{ announce.수행상태 }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <ContractPop v-if="contractFlag" :data="clickData.계약서" @close="contractClose" :seq="clickData.공고순번" :seq2="seq" :type="'U'"></ContractPop>
</template>

<script setup lang="ts">
import { onMounted, ref, computed } from "vue";
import { useRouter } from "vue-router";
import announceAPI from "@/api/announceAPI";
import loginAPI from "@/api/loginAPI";
import noticeAPI from "@/api/noticeAPI";
import { Announce, ApiResponse, Notice } from "@/common/types";
import { userStore } from "@/store/userStore";
import { convertDate } from "@/utils/utils";
import { Options, Splide, SplideSlide } from "@splidejs/vue-splide";
import { onBeforeRouteLeave } from "vue-router";
import ContractPop from "@/components/popup/ContractPop.vue";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";
import bannerAPI from "@/api/bannerAPI";

const store = userStore();
const router = useRouter();
const announceList = ref<Announce[]>([]);
const noticeList = ref<Notice[]>([]);

const clickData = ref<Announce>({} as Announce);
const seq = ref();
const contractFlag = ref(false);
const contractClose = () => {
  contractFlag.value = false;
};

const options: Options = {
  type: "fade",
  rewind: true,
  DragEvent: true,
  perPage: 1,
  autoplay: true,
  pauseOnHover: false,
  arrows: true,
  dots: true,
  animatedDots: true,
  direction: "ltr",
};

onBeforeRouteLeave((to, from, next) => {
  console.log(to,from,"to,from");
  // Skip the check if already navigating to certificateApproval to prevent loops
  if (to.name === 'certificateApproval') {
    next();
    return;
  }
  
  if (store.isLogin && store.userInfo.가입상태 === '신청') {
    if(to.name === "announce" || to.name === "mypage" || to.name === "resourceBoard") {    
      next({ name: "certificateApproval" });
    } else {
      next();
    }
  } else {
    next();
  }
});
onMounted(() => {
  getBanner();
  getNoticeList();
  if (store.isLogin) {
    getMainAnnounceList();
  }
});
const bannerList:any = ref([])
const getBanner = () => {
  bannerList.value = [];
  bannerAPI.getBanner().then((res) => {
    bannerList.value = res.data.data; // 전체 배너 데이터 저장
  })
}
const getNoticeList = () => {
  noticeAPI.noticeList({limit:4}).then((res) => {
    noticeList.value = res.data.data; // 전체 공지사항 데이터 저장
  });
};

const getMainAnnounceList = () => {
  announceAPI.announceList({limit:4,진행여부:true}).then((res) => {
    announceList.value = res.data.data; // 전체 공고 데이터 저장
  });
};

const goNoticeDetail = (data: Notice) => {
  router.push({ name: `noticeDetail`, params: { seq: data.공지순번 } });
};

const goAnnounceDetail = (data: Announce) => {
  
  if(store.userInfo.가입상태 === '신청') {
    alert("가입승인 후 이용하실 수 있습니다.");
    router.push({ name: "certificateApproval" });
    return;
  }
  if(!data.계약서) {
    alert("등록된 계약서가 없습니다.");
    router.push({ name: `announceDetail`, params: { seq: data.공고순번 } });
  }
  if(data.계약서[`${data.수주수행구분}계약서작성여부`]) {
    router.push({ name: `announceDetail`, params: { seq: data.공고순번 } });
  } else {
    alert("계약서 작성이 완료되지 않았습니다.");
    clickData.value = data
    seq.value = data.계약서.저장파일.저장순번
    contractFlag.value = true
  }
};

const goPage = (page: string) => {
  if (page === "announce" || page === "mypage" || page === "resourceBoard") {
    if (store.isLogin == false) {
      alert("로그인 후 이용하실 수 있습니다.");
      router.push({ name: "login" });
      return;
    } else {
      if(store.userInfo.가입상태 === '신청') {
        alert("가입승인 후 이용하실 수 있습니다.");
        router.push({ name: "certificateApproval" });
        return;
      }
      window.scrollTo({ top: 0, behavior: "auto" });
      router.push({ name: page });
      return;
    }
  }
  window.scrollTo({ top: 0, behavior: "auto" });
  router.push({ name: page });
};

const goLink = (data:any) => {
  if(data.구분 === '내부') {
    window.location.href = data.호출경로;
  } else {
    window.open(data.호출경로, "blank");
  }
};

const logout = () => {
  if (window.confirm("로그아웃 하시겠습니까?")) {
    loginAPI.logout().then(() => {
      store.logout();
      router.push({ name: "home" });
    });
  }
};
</script>

<style scoped>
.home_top_div {
  padding-top: 30px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  width: 841px;
}

.user_info_div {
  min-width: 401px;
  height: 317px;
  border: 1px solid #d0d0d0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 46px 30px 34px 30px;
  box-shadow: 4px 4px 8px 0px #0000000d;
  border-radius: 15px;
}

.user_info_img {
  margin-bottom: 10px;
}

.mypage_info_img {
  margin-bottom: 2px;
}

.user_info_desc {
  font-size: 15px;
  font-family: "Noto Sans CJK KR-Bold";
  line-height: 21px;
  margin-bottom: 10px;
}

.mypage_info_div {
  min-width: 401px;
  height: 317px;
  border: 1px solid #dfdfdf;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10px 30px 10px 30px;
  box-shadow: 4px 4px 8px 0px #0000000d;
  border-radius: 15px;
}

.home_main_div {
  padding: 20px 0px 70px 0px;
  display: flex;
  gap: 20px;
}

.home_menu_div {
  min-width: 400px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.home_menu {
  border: 1px solid #dfdfdf;
  width: 200px;
  height: 153px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 11px;
  cursor: pointer;
}

.home_menu_label {
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 16px;
  line-height: 21px;
  color: black;
}

.home_announce_header {
  display: flex;
  /* gap: 20px; */
}

.main_btn {
  background: #3382e9;
  width: 100%;
  display: flex;
  height: 37px;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  color: white;
  font-family: "Noto Sans CJK KR-Bold";
  cursor: pointer;
  height: 51px;
}

.main_btn:hover {
  background: #285a8e;
}

.main_sub_btn {
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
  border-bottom: 1px solid black;
  line-height: 14px;
  padding-bottom: 7px;
  cursor: pointer;
}

.announce_category_tab {
  width: 59px;
  display: flex;
  line-height: 22px;
  padding-bottom: 7px;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: bold;
  border-bottom: 3px solid black;
  z-index: 1;
}

.main_table_div {
  width: 100%;
  border-top: 1px solid #e6e6e6;
  height: 236px;
  padding: 30px 0px;
  margin-top: -2px;
}

.main_notice_ul {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.main_notice_li {
  display: flex;
  justify-content: space-between;

  cursor: pointer;
  font-size: 13px;
  flex-direction: column;
  gap: 2px;
}

.main_notice_title {
  height: 19px;
  line-height: 19px;
  font-size: 14px;
  color: black;
  font-family: "Noto Sans CJK KR-Regular";
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.main_notice_date {
  height: 19px;
  line-height: 19px;
  font-size: 14px;
  color: black;
  font-family: "Noto Sans CJK KR-Regular";
}

.home_announce_div {
  min-width: 401px;
  display: flex;
  flex-direction: column;
  height: 325px;
  border: 1px solid #dfdfdf;
  border-radius: 15px;
  padding: 21px 31px 0px 36px;
}

.no_login_div {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Bold";
  height: 100%;
  color: #aaa;
}

.user_info_btn_group {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 22px;
}

.title_menu_li {
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
  border-bottom: 1px solid black;
  line-height: 14px;
  margin-top: 22px;
  cursor: pointer;
  color: #232a58;
  text-decoration: underline;
  text-decoration-thickness: 0.5px;
  text-underline-offset: 5px;
}

.profile-type {
  background: #f6f7fb;
  border: 1px solid #ededed;
  width: 67px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12.5px;
  font-family: "Noto Sans CJK KR-Medium";
  font-size: 10px;
  cursor: pointer;
}

.profile-div {
  padding-bottom: 15px;
}

.main_img {
  cursor: pointer;
}

#mainslider {
  width: 100%;
  min-width: 841px;
  cursor: pointer;
  border-radius: 6px;
}
</style>
